import axios, { AxiosError } from 'axios';
import { HttpErrorResponse, HttpException } from '@client/core/exception/http-exception';
import { reportException } from '@client/core/exception/report-exception';
import {
  HttpErrorResponseWithValidationErrors,
  ValidationException,
} from '@client/core/exception/validation-exception';
import HttpStatusCode from '@client/core/http/status-codes';

/**
 * Invoked when our HTTP API encounters an unsuccessful HTTP Response. This
 * can range from a well-formed JSON HTTP Response with a proper response body
 * (best case scenario), to a low-level error with a generic error message
 * (worst case.)
 */
export function defaultHttpExceptionCatch(e: unknown): Error | unknown {
  const errors = e as Error | AxiosError<HttpErrorResponse> | AxiosError<HttpErrorResponseWithValidationErrors, any>;

  if (!axios.isAxiosError(errors)) {
    return errors;
  }

  if (errors.response?.status === HttpStatusCode.UNPROCESSABLE_ENTITY) {
    return new ValidationException(errors as AxiosError<HttpErrorResponseWithValidationErrors, any>);
  }

  if (errors.response?.status === HttpStatusCode.NOT_FOUND) {
    reportException(e as Error);
  }

  return new HttpException(errors as AxiosError<HttpErrorResponse>);
}

export function isAxiosError(data: AxiosError | any): data is AxiosError {
  return data && (<AxiosError>data).isAxiosError !== undefined;
}
